import React, { useEffect, useState } from "react"
import KOL from "../../Model/KOL"
import { useDispatch, useSelector } from "react-redux"
import {
  getCaseStudies,
  getKOLPlans,
} from "../../HelpingFunction/KOL/kolDBHelper"
import { CaseStudy } from "../../Model/CaseStudy"

import { Plan } from "../../Model/Plan"
import KOLPlanItem from "../home/KOLPlanItem"
import { SUPPORTED_REDUX_FUNCTIONS } from "../../Redux/SUPPORTED_REDUX_FUNCTION"
import { SUPPORTED_MODAL_TYPE } from "../../Utils/ModalType"
import CaseStudyCard from "../../Component/CaseStudyCard"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Trans } from "react-i18next"

import classNames from "classnames"
import { SCROLL_DIR } from "../../Enum/PROFILE_TYPE"
import { CustomCarousel } from "../../Component/NewCarousel"
import { CAROUSEL_TYPE } from "../../Enum/CAROUSEL_SYSTEM"

interface workProps {
  type: string
}

const KOLWork: React.FC<workProps> = (props) => {
  const dispatch = useDispatch()
  const profile: KOL = useSelector((state: any) => {
    return state.KOLInfoManager.kolInfo
  })
  const auth = useSelector((state: any) => {
    return state.firebase.auth
  })
  const screenWidth = useSelector((state: any) => {
    return state.SystemManager.screenWidth
  })

  const [cases, setCases] = useState<CaseStudy[]>([])
  const [plans, setPlans] = useState<Plan[]>([])
  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  const [leftScrollCaseDisable, setLeftScrollCaseDisable] =
    useState<boolean>(false)
  const [rightScrollCaseDisable, setRightScrollCaseDisable] =
    useState<boolean>(false)
  const [leftScrollPlanDisable, setLeftScrollPlanDisable] =
    useState<boolean>(false)
  const [rightScrollPlanDisable, setRightScrollPlanDisable] =
    useState<boolean>(false)

  useEffect(() => {
    getCaseStudies(profile.id, false, false)
      .then((result) => {
        if (result.success) {
          setCases(result.data)
          setIsLoaded(true)
        } else {
          setCases([])
          setIsLoaded(true)
        }
      })
      .catch((err) => console.log(err))
  }, [profile])
  useEffect(() => {
    getKOLPlans(profile.id, true).then((res) => {
      if (res.success) {
        setPlans(res.data)
      } else {
        setPlans([])
      }
    })
  }, [profile])

  function scrollCarousel(scrollDirection: SCROLL_DIR, id: string) {
    const carouselElement = document.getElementById(id)
    if (carouselElement) {
      let carouselWidth = carouselElement.clientWidth

      let scrollLeft = carouselElement.scrollLeft

      let targetXPixel = 0
      switch (scrollDirection) {
        case SCROLL_DIR.LEFT:
          targetXPixel = scrollLeft - carouselWidth + 1
          break
        case SCROLL_DIR.RIGHT:
          targetXPixel = scrollLeft + carouselWidth + 1
          break
        default:
          break
      }
      carouselElement.scrollTo(targetXPixel, 0)
    }
  }

  const scrollChecker = (id: string) => {
    switch (id) {
      case "case-carousel":
        setLeftScrollCaseDisable(false)
        setRightScrollCaseDisable(false)
        break
      case "plan-carousel":
        setLeftScrollPlanDisable(false)
        setRightScrollPlanDisable(false)
        break
      default:
        break
    }
    let ele = document.getElementById(id)
    const scrollOffset = 5

    let scrollLeft = ele!.scrollLeft
    let scrollWidth = ele!.scrollWidth
    let offsetWidth = ele!.offsetWidth
    let contentWidth = scrollWidth - offsetWidth - scrollOffset

    switch (id) {
      case "case-carousel":
        if (contentWidth <= scrollLeft || contentWidth <= 0) {
          setRightScrollCaseDisable(true)
        }
        if (0 >= scrollLeft) {
          setLeftScrollCaseDisable(true)
        }
        break
      case "plan-carousel":
        if (contentWidth <= scrollLeft || contentWidth <= 0) {
          setRightScrollPlanDisable(true)
        }
        if (0 >= scrollLeft) {
          setLeftScrollPlanDisable(true)
        }
        break
      default:
        break
    }
  }

  const hlaScroll = (id: string) => {
    let ele = document.getElementById(id)
    ele!.onscroll = async function () {
      scrollChecker(id)
    }.bind(this)
  }

  useEffect(() => {
    if (isLoaded && props.type === "case") {
      if (document.getElementById("case-carousel")) {
        scrollChecker("case-carousel")
        //componentWillUnmount
        document
          .getElementById("case-carousel")!
          .addEventListener("scroll", () => hlaScroll("case-carousel"))
      }
      if (document.getElementById("plan-carousel")) {
        scrollChecker("plan-carousel")
        //componentWillUnmount
        document
          .getElementById("plan-carousel")!
          .addEventListener("scroll", () => hlaScroll("plan-carousel"))
      }
    }

    return () => {
      // componentDidMount
      if (document.getElementById("case-carousel")) {
        document
          .getElementById("case-carousel")!
          .removeEventListener("scroll", () => hlaScroll("case-carousel"))
      }
      if (document.getElementById("plan-carousel")) {
        document
          .getElementById("plan-carousel")!
          .removeEventListener("scroll", () => hlaScroll("plan-carousel"))
      }
    }
  }, [isLoaded, props.type])

  const setCaseStudyModal = (state: any) =>
    dispatch({
      type: SUPPORTED_REDUX_FUNCTIONS.TOGGLE_MODAL,
      typeOfModal: SUPPORTED_MODAL_TYPE.CASE_STUDY_MODAL,
      returnFn: state.returnFn,
      metaData: state.metaData,
    })

  if (isLoaded) {
    return (
      <div className="w-full md:pt-2 md:p-2 pt-8 md:px-0 px-2">
        <section className="my-4 h-full">
          <h2 className="text-2xl text-left font-medium m-2 text-red-default">
            <Trans>KOLProfile.service-plan</Trans>
          </h2>
          <CustomCarousel
            dataSets={plans}
            isLoaded={isLoaded && props.type === "case"}
            displayComponent={(data, index) => <KOLPlanItem data={data} />}
            shownConditions={(data, index) => data.isVisible}
            indexName={CAROUSEL_TYPE.PLAN}
            emptyDataMessage={"KOLProfile.no-plan"}
          />
        </section>
        <section className="my-4">
          <h2 className="text-2xl text-left font-medium m-2 text-red-default ">
            <Trans>KOLProfile.case-study</Trans>
          </h2>
          <CustomCarousel
            dataSets={cases}
            isLoaded={isLoaded && props.type === "case"}
            displayComponent={(data, index) => (
              <CaseStudyCard
                key={"csc" + index}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                setCaseStudyModal={setCaseStudyModal}
                data={data}
                auth={auth}
                index={index}
              />
            )}
            indexName={CAROUSEL_TYPE.CASE_STUDY}
            emptyDataMessage={"KOLProfile.no-case-study"}
          />
        </section>
      </div>
    )
  }
  return <div />
}

export default KOLWork
